module.exports = __webpack_public_path__ + "static/flags/SG-b61977f912e4fa476293a6de023f724a.gif";